/* ISA ROSE — interacciones propias (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.ir-reveal:not(.ir-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ir-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ir-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initManifesto() {
    document.querySelectorAll('[data-ir-words]').forEach(function (el) {
      if (el.dataset.irDone) return;
      el.dataset.irDone = '1';
      var walk = function (node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              var s = document.createElement('span'); s.className = 'ir-word'; s.textContent = part; frag.appendChild(s);
            });
            child.parentNode.replaceChild(frag, child);
          } else if (child.nodeType === 1) { walk(child); }
        });
      };
      walk(el);
    });
  }

  var scrollers = [];
  function onScroll() {
    var vh = window.innerHeight;
    document.querySelectorAll('[data-ir-words]').forEach(function (el) {
      var words = el.querySelectorAll('.ir-word');
      var r = el.getBoundingClientRect();
      var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      p = Math.max(0, Math.min(1, p));
      var n = reduce ? words.length : Math.round(p * words.length);
      words.forEach(function (w, i) { w.classList.toggle('ir-on', i < n); });
    });
    if (reduce) return;
    document.querySelectorAll('[data-ir-parallax]').forEach(function (el) {
      var k = parseFloat(el.getAttribute('data-ir-parallax')) || 0;
      var r = el.parentElement.getBoundingClientRect();
      var c = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (c * k * -1).toFixed(1) + 'px,0) scale(1.06)';
    });
    scrollers.forEach(function (fn) { fn(); });
  }
  var ticking = false;
  function requestScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; onScroll(); });
  }

  function initProduct() {
    document.querySelectorAll('[data-ir-pdp]').forEach(function (root) {
      if (root.dataset.irDone) return;
      root.dataset.irDone = '1';
      var main = root.querySelector('[data-ir-main]');
      root.querySelectorAll('[data-ir-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          root.querySelectorAll('[data-ir-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (main) {
            main.style.opacity = 0;
            setTimeout(function () { main.src = t.dataset.irThumb; main.srcset = ''; main.style.opacity = 1; }, 180);
          }
        });
      });

      var qty = root.querySelector('[data-ir-qty]');
      root.querySelectorAll('[data-ir-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          v = Math.max(1, v + parseInt(b.dataset.irQtyBtn, 10));
          qty.value = v;
          qty.dispatchEvent(new Event('input'));
        });
      });

      root.querySelectorAll('[data-ir-pack-qty]').forEach(function (r) {
        var apply = function () { if (r.checked && qty) qty.value = r.dataset.irPackQty; };
        r.addEventListener('change', apply);
        apply();
      });
      if (qty) qty.addEventListener('input', function () {
        root.querySelectorAll('[data-ir-pack-qty]').forEach(function (r) { r.checked = r.dataset.irPackQty === String(parseInt(qty.value, 10)); });
      });

      var json = root.querySelector('[data-ir-variants]');
      var idInput = root.querySelector('input[name="id"]');
      var btns = root.querySelectorAll('[data-ir-add]');
      var priceEl = root.querySelector('[data-ir-price]');
      var compareEl = root.querySelector('[data-ir-compare]');
      var fmt = root.dataset.irMoney || '{{amount_with_comma_separator}} €';
      function money(cents) {
        var n = (cents / 100).toFixed(2);
        var comma = n.replace('.', ',');
        return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma).replace(/\{\{\s*amount\s*\}\}/, n);
      }
      if (json) {
        var variants = JSON.parse(json.textContent);
        root.querySelectorAll('[data-ir-option]').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var sel = [];
            root.querySelectorAll('[data-ir-option-group]').forEach(function (g) {
              var c = g.querySelector('input:checked'); sel.push(c ? c.value : null);
            });
            var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
            if (!v) return;
            idInput.value = v.id;
            if (priceEl) priceEl.textContent = money(v.price);
            if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
            btns.forEach(function (b) {
              b.disabled = !v.available;
              b.querySelector('[data-ir-add-label]').textContent = v.available ? b.dataset.irAvailable : b.dataset.irSoldout;
            });
            if (v.featured_image && main) { main.src = v.featured_image; main.srcset = ''; }
            var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          });
        });
      }

      var bar = root.querySelector('[data-ir-sticky-bar]');
      var form = root.querySelector('[data-ir-buy]');
      if (bar && form) {
        bar.querySelector('button').addEventListener('click', function () {
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        scrollers.push(function () {
          var r = form.getBoundingClientRect();
          bar.classList.toggle('is-shown', r.bottom < 0);
        });
      }
    });
  }

  function initAll() {
    initManifesto();
    initReveal();
    initProduct();
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('scroll', requestScroll, { passive: true });
  window.addEventListener('resize', requestScroll);
  document.addEventListener('shopify:section:load', initAll);
})();
